/**
 * Insights Dashboard Page
 *
 * This is a placeholder component - the actual Insights iframe is rendered
 * by PersistentInsights in MainLayout to keep it mounted across navigation.
 *
 * This component exists only to:
 * 1. Satisfy the router (so /insights is a valid route)
 * 2. Provide a fallback if PersistentInsights hasn't mounted yet
 *
 * The PersistentInsights component shows/hides itself based on the route,
 * so this page renders nothing (the iframe is shown by the layout).
 */

export function InsightsDashboardPage() {
  // PersistentInsights in MainLayout handles the actual iframe rendering
  // This component returns null since the layout takes care of everything
  return null;
}
